import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";

import { User } from "../_models/index";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/catch';
import { StaticInjector } from "@angular/core/src/di/injector";
import { DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';


@Injectable()
export class UserService {
    getEscalationLevelList(): any {
      throw new Error('Method not implemented.');
    }
    constructor(private http: Http, private cookieService: CookieService,
        private decryptpipe: DecryptPipe
    ) {
    }

    verify() {
        return this.http.get(environment.apiUrl + 'api/Account/verify', this.jwt()).map((response: Response) => response.json());
    }

    forgotPassword(Email: string) {
        return this.http.post(environment.apiUrl + 'api/Manage/ForgotPassword?Email=' + Email, null)
            .map((response: Response) => response.json());
    }

    resetPassword(ResetPassword: any) {
        return this.http.post(environment.apiUrl + 'api/Manage/ResetPassword', ResetPassword, null)
            .map((response: Response) => response.json());
    }

    setPassword(SetPassword: any) {
        return this.http.post(environment.apiUrl + 'api/Account/SetPassword', SetPassword, null)
            .map((response: Response) => response.json());
    }

    validateToken(ValidateToken: any) {
        return this.http.post(environment.apiUrl + 'api/Manage/ValidateToken', ValidateToken, null).map((response: Response) => response.json()
        )
    }

    getAll() {
        return this.http.get('/api/users', this.jwt()).map((response: Response) => response.json());
    }

    getById(id: number) {
        return this.http.get('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    create(user: User) {
        return this.http.post('/api/users', user, this.jwt()).map((response: Response) => response.json());
    }

    update(user: User) {
        return this.http.put('/api/users/' + user.Id, user, this.jwt()).map((response: Response) => response.json());
    }

    delete(id: number) {
        return this.http.delete('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    }

    getByIdWhiteLable(id: string) {
        return this.http.get(environment.apiUrl + 'api/Common/GetSystemSettingByName/' + id).map((response: Response) => response.json());
    }

    getByIdRightsCheck(id: any, param1: any) {
        return this.http.get(environment.apiUrl + 'api/Common/GetSystemSettingByName/?id=' + id + '&param1=' + param1).map((response: Response) => response.json());
    }

    // private helper methods`
    private jwt() {
        // create authorization header with jwt token
        // let currentUser = JSON.parse(this.cookieService.get("User") || "{}");
        let currentUser = this.cookieService.get("user_access_token");
        // if (currentUser && currentUser.access_token) {
        if (currentUser) {
            currentUser = this.decryptpipe.transform(JSON.parse(currentUser));
            let headers = new Headers();
            headers.append("Authorization", "Bearer " + currentUser);
            return new RequestOptions({ headers: headers });
        }
    }

    //added by vithujan 25-06-2024
    forgotPasswordNew(Email: string) {
        return this.http.post(environment.apiUrl + 'api/Manage/ForgotPasswordNew?Email=' + Email, null)
            .map((response: Response) => response.json());
    }
}